import { useCleanPathname } from '@/hooks/use-clean-pathname';
import { useEffect } from 'react';

export function HashDeepLinks() {
  const pathname = useCleanPathname();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleDeepLink = () => {
      const hash = window.location.hash.slice(1);
      if (!hash) return;

      const element = document.getElementById(hash);
      if (!element) return;

      const headerElement = document.getElementById('app-header');

      let headerHeight = 0;
      if (headerElement) {
        const headerRect = headerElement.getBoundingClientRect();
        headerHeight = headerRect.height;
      }

      const extraPadding = 20;
      const totalOffset = headerHeight + extraPadding;

      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - totalOffset;

      window.scrollTo({
        top: Math.max(0, offsetPosition),
        behavior: 'instant'
      });
    };

    const handleDeepLinkWithRAF = () => {
      setTimeout(() => {
        requestAnimationFrame(handleDeepLink);
      }, 50);
    };

    handleDeepLinkWithRAF();
  }, [pathname]);

  return null;
}
